import { trpc } from "@/util/trpc";
import { Confirm } from "./common/confirm";

export function PayoutConfirm({
    method,
    claims,
    onSuccess,
    goBack,
    onAddressEdit,
    onBankDetailsEdit,
    onVatEdit,
}: {
    method: "bank" | "crypto";
    claims: { type: "campaign" | "youtube"; id: string }[];
    onSuccess: () => void;
    goBack: () => void;
    onAddressEdit: () => void;
    onBankDetailsEdit: () => void;
    onVatEdit: () => void;
}) {
    const { data: payoutsSummary } = trpc.edge.utils.getPayoutsSummary.useQuery({
        filter: claims,
    });

    const utils = trpc.useUtils();

    const claimPayouts = trpc.lambda.dashboard.claimPayouts.useMutation({
        onSuccess: async () => {
            await utils.invalidate();
            onSuccess();
        },
    });

    if (payoutsSummary == null) return null;

    return (
        <Confirm
            method={method}
            onClick={() => {
                claimPayouts.mutate({
                    method,
                    claims,
                });
            }}
            isLoading={claimPayouts.isPending}
            amount={(+payoutsSummary.amountWithFeeSubtracted).toLocaleString("en-US", {
                style: "currency",
                currency: payoutsSummary.totalCurrency,
            })}
            currency={payoutsSummary.totalCurrency}
            goBack={goBack}
            onAddressEdit={onAddressEdit}
            onBankDetailsEdit={onBankDetailsEdit}
            onVatEdit={onVatEdit}
        />
    );
}
